import './Footer.css'

const Footer = () => {
    return (
        <div id="footer">
            <p>Designed And Developed by <a href='https://github.com/sanjeetsk'>@Sanjeet</a></p>
        </div>
    )
}

export default Footer